import { Tag as ChakraTag } from '@chakra-ui/react';

export default function Tag({ label, ...rest }) {
 return (
  <ChakraTag
   bg='green.200'
   color='black.100'
   fontSize='14px'
   px='8px'
   fontWeight={400}
   {...rest}
  >
   {label}
  </ChakraTag>
 );
}
